import { IconsObject } from "../../assets/Menu Icons/Icons";

export const menus = [
    { menuName: "Dashboard", menuIcon: IconsObject.dashboardIcon(27), path: "/admin/dashboard" },
    { menuName: "Announcement", menuIcon: IconsObject.announcementIcon(27), path: "/admin/announcement" },
    // { menuName: "Event", menuIcon: IconsObject.eventIcon(27), path: "event", path: "/admin/event" },
    // { menuName: "News", menuIcon: IconsObject.newsIcon(27), path: "news", path: "/admin/news" },
    {
        menuName: "IQAC", menuIcon: IconsObject.reportsIcon(27),
        subMenus: [
            { subMenuName: "Academic Audit Report", path: "/admin/iqac/academic-audit-template" },
            { subMenuName: "Best Practices", path: "/admin/iqac/best-practices" },
            { subMenuName: "Assessment Criteria", path: "/admin/iqac/assessment-criteria" },
            { subMenuName: "Minutes", path: "/admin/iqac/minutes-page" },
            { subMenuName: "AQARS", path: "/admin/iqac/aqars-page" },
            { subMenuName: "Calendar/Handbook", path: "/admin/iqac/calender-handbook-page" },
            { subMenuName: "Outcomes", path: "/admin/iqac/outcomes-page" },
            { subMenuName: "NIRF", path: "/admin/iqac/nirf-page" },
            { subMenuName: "AISHE", path: "/admin/iqac/aishe-page" },
            { subMenuName: "SSS", path: "/admin/iqac/sss-page" },
            { subMenuName: "Distinctiveness", path: "/admin/iqac/distinctiveness-page" },
        ]
    },
    { menuName: "Academic Calendar", menuIcon: IconsObject.calendarIcon(27), path: "/admin/academic-calendar" },
    { menuName: "Study Materials", menuIcon: IconsObject.bookIcon(27), path: "/admin/study-materials" },
    {
        menuName: "Alumini", menuIcon: IconsObject.achieversGalleryIcon(27),
        subMenus: [
            { subMenuName: "Newsletter", path: "/admin/alumini/newsletter" },
            { subMenuName: "Achievers Gallery", path: "/admin/alumini/achievers-gallery" },
        ]
    },
    {
        menuName: "Help Desk", menuIcon: IconsObject.helpDeskIcon(27),
        subMenus: [
            { subMenuName: "Students & Parents", path: "/admin/helpdesk/students-parents-page" },
            { subMenuName: "Visitors", path: "/admin/helpdesk/visitors-page" }
        ]
    },
    { menuName: "Gallery", menuIcon: IconsObject.galleryIcon(27), path: "/admin/gallery-page" },
    {
        menuName: "Feedback", menuIcon: IconsObject.feedbackIcon(27),
        subMenus: [
            { subMenuName: "Student's Feedback", path: "/admin/feedback/students-feedback-page" },
            { subMenuName: "Staff's Feedback", path: "/admin/feedback/teachers-feedback-page" },
            { subMenuName: "Parent's Feedback", path: "/admin/feedback/parents-feedback-page" },
        ]
    },
    { menuName: "Application for Staff", menuIcon: IconsObject.applictaionIcon(27), path: "/admin/staff-application-page" },
    { menuName: "Ombudsman", menuIcon: IconsObject.ombudsmanIcon(27), path: "/admin/ombudsman-page" },
    {
        menuName: "Application For Admission", menuIcon: IconsObject.admissionIcon(27), path: "/admin/admission/application-for-admisssion"
    },
    {
        menuName: "Contact Messages", menuIcon: IconsObject.contactIcon(27), path: "/admin/contact-messages"
    }
];

